import React, { Component } from "react";

export default class PasswordConditions extends Component {
  render() {
    return (
      <div className="conditions-wrapper">
        <ul>
          
          <li className={this.props.lowercase ? "validCharacter" : "invalidCharacter"}>
            At least 1 lower case letter
          </li>
          <li className={this.props.uppercase ? "validCharacter" : "invalidCharacter"}>
            At least 1 upper case letter
          </li>
          <li className={this.props.charLength ? "validCharacter" : "invalidCharacter"}>
            At least 8 characters
          </li>
          <li className={this.props.number ? "validCharacter" : "invalidCharacter"}>At least 1 number</li>
          {this.props.requiresSpecialChar && (
            <>
            <li className={this.props.specialChar ? "validCharacter" : "invalidCharacter"}>
            At least 1 special character (only !#+,-/:=@_)
          </li>
          <li className={this.props.noConsecutiveRepeats ? "validCharacter" : "invalidCharacter"}>
            No consecutive 8 identical characters
          </li>
          <li className={this.props.firstCharNotSpecial ? "validCharacter" : "invalidCharacter"}>
            The first character must not be special
          </li>
          <li className={this.props.maxLength ? "validCharacter" : "invalidCharacter"}>
            No more than 63 characters
          </li>
          </>
          )}
          
          <li className={this.props.dot ? "validCharacter" : "invalidCharacter"}>May not contain "."</li>
        </ul>
      </div>
    );
  }
}
